import { atom } from "jotai";

export const uiAssetFrontendLanguageState = atom<string>(
  "en"
);

